export default __webpack_public_path__ + "static/media/googlePlayLogo.5c077679.png";